import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Language } from '../../../configs/language';
import { CountryLanguage, LANGUAGE_COUNTRY } from '../../../constants/leng';

export interface LanguageState {
  country: CountryLanguage;
  language: Language;
}

const userLang: string = navigator.language || 'en';
const appLang = userLang.includes('en') ? 'EN' : 'ES';

const initialState: LanguageState = {
  country:
    (LANGUAGE_COUNTRY[
      sessionStorage.getItem('language') as Language
    ] as CountryLanguage) ?? 'MX',
  language: (sessionStorage.getItem('language') as Language) ?? appLang,
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    changeLanguage: (state, action: PayloadAction<LanguageState>) => {
      sessionStorage.setItem('language', action.payload.language);
      state.country = action.payload.country;
      state.language = action.payload.language;
    },
  },
});

export const { changeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
